import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Tenant } from '../Models/tenant';
import { TenantService } from '../Services';
import { MaintenanceTaskSchedulerDataService } from './maintenance-task-scheduler-data.service';
import { RecurringScheduledMaintenanceTaskSeriesSummary } from './scheduled-maintenance-recurrence.model';
import { ScheduledMaintenanceSummary } from './scheduled-maintenance-summary.model';
import { ScheduledMaintenanceTask } from './scheduled-maintenance-task.model';
import { MatCard, MatCardTitle, MatCardSubtitle } from '@angular/material/card';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MaintenanceTaskComponent } from './maintenance-task.component';
import { MaintenanceScheduleComponent } from './maintenance-schedule/maintenance-schedule.component';
import { MaintenanceSeriesDetailComponent } from './series/maintenance-series-detail.component';

@Component({
    selector: 'maintenance-task-scheduler',
    templateUrl: './maintenance-task-scheduler.component.html',
    styleUrls: ['maintenance-task-scheduler.component.less'],
    providers: [Title],
    imports: [MatCard, MatCardTitle, MatCardSubtitle, MatProgressSpinner, AsyncPipe, MaintenanceTaskComponent, MaintenanceScheduleComponent, MaintenanceSeriesDetailComponent]
})
export class MaintenanceTaskSchedulerComponent implements OnInit, OnDestroy {
  activeTab$: Subject<string> = new Subject<string>();
  title = 'Maintenance Task Scheduler';
  description = 'Maintenance tasks can be scheduled for execution on a specified list of tenants';
    migrationTasks: ScheduledMaintenanceTask[];
    schedules: ScheduledMaintenanceSummary[];
    allTenants$: Observable<Tenant[]>;
    recurringSeries$: Observable<RecurringScheduledMaintenanceTaskSeriesSummary[]>;
    destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
      private readonly maintenanceTaskSchedulerDataService: MaintenanceTaskSchedulerDataService,
      private readonly tenantService: TenantService
  ) {}

  ngOnInit(): void {
      this.getMigrationTasks();
      this.refreshSchedules();
      this.getAllTenants();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    }

    getSchedulesForTask(task: ScheduledMaintenanceTask): ScheduledMaintenanceSummary[] {
        if (!this.schedules) {
            return [];
        }

        return this.schedules
            .filter(schedule => schedule.TaskTypeName === task.TaskTypeName)
            .sort((a, b) => (a.StartDate < b.StartDate) ? 1 : -1)
            .slice(0, 5);
    }

  private getMigrationTasks(): void {
    this.maintenanceTaskSchedulerDataService.getMigrationTasks()
      .pipe(takeUntil(this.destroy$))
      .subscribe((tasks: ScheduledMaintenanceTask[]) => {
        this.migrationTasks = tasks;
      });
    }

    refreshSchedules(): void {
        this.getAllSchedules();
        this.loadRecurringSeries();
    }

    getAllSchedules(): void {
        this.maintenanceTaskSchedulerDataService.getAllSchedules()
            .pipe(takeUntil(this.destroy$))
            .subscribe((schedules: ScheduledMaintenanceSummary[]) => {
                this.schedules = schedules;
            });
    }

    loadRecurringSeries(): void {
        this.recurringSeries$ = this.maintenanceTaskSchedulerDataService.getRecurringScheduledMaintenanceTaskSeries();
    }

    private getAllTenants(): void {
        this.allTenants$ = this.tenantService.getAllProvisionedTenants();
    }

}
